import { Suspense } from "react";
import { useLocalSearchParams } from "expo-router";
import { View } from "tamagui";

import { LoadingScreen } from "~/components/blocks";
import { UsersTableFilterProvider } from "~/components/blocks/filters/users-table-filter";
import {
  GroupHeader,
  UsersTable,
} from "~/components/feature/groups-management/group";

const Group = () => {
  const groupId = useLocalSearchParams().groupId as string;
  return (
    <UsersTableFilterProvider>
      <View gap={"$5"}>
        <GroupHeader groupId={groupId} />
        <Suspense fallback={<LoadingScreen height={"100dvh"} width={"100%"} />}>
          <UsersTable groupId={groupId} />
        </Suspense>
      </View>
    </UsersTableFilterProvider>
  );
};
export default Group;
